import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Loader from '../nav/Loader';

const baseResultsURL = "https://www.roadtonationals.com/api/men/fantasysplit";

class Fantasy extends Component {
  constructor(props) {
      let data = [
        {gymnast_id: '333', team_name: 'Air Force', fname: 'Jane', lname: 'Doe', avgv: '10', maxv: '10', avgub: '10', maxub: '10', avgbb: '10', maxbb: '10', avgfx: '10', maxfx: '10', avgaa: '10', maxaa: '10' }
      ];
      let columns = [
        {Header: 'Team', accessor: 'team_name', Cell: props => <a href={'/results/teamsGA/dashboard/'+this.getYear()+'/'+props.original.tid}>{props.value}</a>},
        {Header: 'First', accessor: 'fname', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.getYear()+'/'+props.original.tid+'/'+props.original.gymnast_id}>{props.value}</a>},
        {Header: 'Last', accessor: 'lname', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.getYear()+'/'+props.original.tid+'/'+props.original.gymnast_id}>{props.value}</a>},
        {Header: 'FX Ave', accessor: 'avgfx', className: "highlight-column", width: 80},
        {Header: 'FX Max', accessor: 'maxfx', className: "highlight-column", width: 80},
        {Header: 'PH Ave', accessor: 'avgph', width: 80},
        {Header: 'PH Max', accessor: 'maxph', width: 80},
        {Header: 'SR Ave', accessor: 'avgsr', className: "highlight-column", width: 80},
        {Header: 'SR Max', accessor: 'maxsr', className: "highlight-column", width: 80},
        {Header: 'VT Ave', accessor: 'avgvt', width: 80},
        {Header: 'VT Max', accessor: 'maxvt', width: 80},
        {Header: 'PB Ave', accessor: 'avgpb', className: "highlight-column", width: 80},
        {Header: 'PB Max', accessor: 'maxpb', className: "highlight-column", width: 80},
        {Header: 'HB Ave', accessor: 'avghb', width: 80},
        {Header: 'HB Max', accessor: 'maxhb', width: 80},
        {Header: 'AA Ave', accessor: 'avgaa', className: "highlight-column", width: 80},
        {Header: 'AA Max', accessor: 'maxaa', className: "highlight-column", width: 80},
      ];
      super(props);
      this.state = {
        data: data,
        cols: columns,
        numRows: 0,
        yearFilter: props.yearFilter,
        showLoader: true
      };
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
      this.getYear = this.getYear.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    //console.log(nextProps);
    if(nextProps.yearFilter !== this.state.yearFilter) {
      this.getResults({
        "year": nextProps.yearFilter
      });
      this.setState({
        yearFilter : nextProps.yearFilter,
        showLoader: true
      });
    }
  }
  componentWillMount() {
    this.getResults({
      "year": this.state.yearFilter
    });
  }
  getResults(config) {
    var url = baseResultsURL + '/' + config.year + '/' + 1;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        var length = response.data.length;
        this.setState({
          data : response.data,
          numRows : length,
          showLoader: false
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getYear() {
    return this.state.yearFilter;
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  getChart() {
    if(!this.state.showLoader) {
      return <div className="small-12 columns">
        <ReactTable
          className="-striped -highlight"
          data={this.state.data}
          columns={this.state.cols}
          defaultSortMethod={this.defaultSortMethod}
          showPagination={false}
          defaultPageSize={this.state.numRows}
          pageSize={this.state.numRows}
        />
        <br />
        <p className="note">*This chart displays every gymnast that competed in a particular year as well as their average and high scores for each event and all-around.<br />
        Originally put together to help organize fantasy gymnastics drafts.</p>
      </div>;
    } else {
      return <Loader />;
    }
  }
  render() {
    return (
      <div>
          <div className="row expanded">
              {this.getChart()}
          </div>
      </div>
    );
  }
}

export default Fantasy;



// WEBPACK FOOTER //
// ./src/components/allteams/Fantasy.js